import React from 'react';

const CheckIcon = (props) => (
  <svg width={13} height={10} viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.40667 7.3125L11.4692 0.25C11.6358 0.0833333 11.8303 0 12.0525 0C12.2747 0 12.4692 0.0833333 12.6358 0.25C12.8025 0.416667 12.8858 0.614583 12.8858 0.84375C12.8858 1.07292 12.8025 1.27083 12.6358 1.4375L4.99 9.10417C4.82333 9.27083 4.62889 9.35417 4.40667 9.35417C4.18444 9.35417 3.99 9.27083 3.82333 9.10417L0.24 5.52083C0.0733333 5.35417 -0.00652778 5.15625 0.000416667 4.92708C0.00736111 4.69792 0.0941667 4.5 0.260833 4.33333C0.4275 4.16667 0.625417 4.08333 0.854583 4.08333C1.08375 4.08333 1.28167 4.16667 1.44833 4.33333L4.40667 7.3125Z"
      fill="white"
    />
  </svg>
);

export default CheckIcon;